import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_URL ?? 'http://localhost:8000/api/v1'}/categories`;

export const categoryShowcaseService = {
    fetchPublic: () => axios.get(`${BASE}/seller-public`),
    fetchSubcategories: (slug: string) => axios.get(`${BASE}/seller-public/${encodeURIComponent(slug)}/subcategories`),
};
